<template>
  <div class="dashboard">
    <!--<user-dialog :dialog.sync="dialog"></user-dialog>-->
    <user-import-dialog :dialog.sync="dialogImport" v-if="dialogImport"></user-import-dialog>

    <v-toolbar flat class="secondary lighten-2 elevation-1" dark>
      <v-toolbar-title>
        <span>{{ $t("users_toolbar_title") }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <more-menu v-if="adminview" :items="more_menu" @itemimport="dialogImport = !dialogImport" />
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="users"
      class="elevation-1"
      hide-actions
      :pagination="listConfigPaginationDataTable"
      id="paginationstart"
    >
      <template slot="items" slot-scope="props">
        <tr
          :key="props.item.id"
          @click="$router.push( { name: 'user', params: { userId: props.item.id } })"
        >
          <td>
            <v-avatar size="32px">
              <img v-if="props.item.avatar" :src="props.item.avatar" />
              <v-icon v-else>person</v-icon>
            </v-avatar>
          </td>
          <td class="text-xs-right">{{ props.item.displayName }}</td>
          <td class="text-xs-right">{{ props.item.email }}</td>
          <td class="text-xs-right">
            <role-membership :currentUserId="props.item.firebase_id"></role-membership>
          </td>
          <td class="text-xs-right">{{ props.item.created_date }}</td>
          <td class="text-xs-right">{{ getType(props.item.firebase_id) }}</td>
          <td class="justify-center layout px-0">
            <v-btn icon class="mx-0">
              <v-icon color="teal">edit</v-icon>
            </v-btn>
            <v-btn icon class="mx-0" @click.stop="deleteItem(props.item)">
              <v-icon color="pink">delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
      <template slot="no-data"></template>
    </v-data-table>
    <PaginationControl
      v-if="listConfigPaginationRequired"
      :page-sizes="listConfigPageSizes"
      :length="listConfigPageCount"
      @change="listConfigOnPaginationChange"
    />

    <v-btn fab bottom right color="pink" dark fixed @click="createItem()">
      <v-icon>add</v-icon>
    </v-btn>
  </div>
</template>

<i18n>
  {
    "de": {
      "users_toolbar_title" : "Benutzer",
      "users_import" : "Nutzer importieren",
      "users_avatar" : "Avatar",
      "users_username_lb" : "Benutzername",
      "users_email_lb" : "Email",
      "users_roles_lb" : "Rollen",
      "users_create_date_lb" : "Registriert seit",
      "users_type_lb" : "Typ",
      "users_actions_lb" : "Aktionen",
      "$vuetify.dataIterator.noResultsText" : "Keine Resultate",
      "dataIterator.noResultsText" : "Keine Resultate"
    },
    "en": {
      "users_toolbar_title" : "Users",
      "users_import" : "Import users",
      "users_avatar" : "Avatar",
      "users_username_lb" : "Username",
      "users_email_lb" : "Email",
      "users_roles_lb" : "Roles",
      "users_create_date_lb" : "Registered",
      "users_type_lb" : "Type",
      "users_actions_lb" : "Actions"
    }
  }
</i18n>

<script>
// Dialog TODO -> Machen wir das mit einem Dialog oder nicht?
import UserImportDialog from "@/components/dialogs/UserImportDialog.vue";

// Snippets
import RoleMembership from "@/components/snippets/RoleMembership.vue";
import MoreMenu from "@/components/snippets/MoreMenu.vue";
import PaginationControl from "@/components/controls/PaginationControl";
import ListConfigurationMixin from "@/components/mixins/ListConfigurationMixin";

import { mapGetters, mapActions } from "vuex";
import { api } from "@/store/modules/users";

export default {
  name: "users",
  components: { RoleMembership, MoreMenu, UserImportDialog, PaginationControl },
  data() {
    return {
      dialog: false,
      dialogImport: false,

      more_menu: [{ title: this.$i18n.t("users_import"), event: "itemimport" }],
      headers: [
        {
          text: this.$i18n.t("users_avatar"),
          align: "left",
          sortable: true,
          value: "avatar"
        },
        { text: this.$i18n.t("users_username_lb"), value: "displayName" },
        { text: this.$i18n.t("users_email_lb"), value: "email" },
        { text: this.$i18n.t("users_roles_lb"), value: "roles" },
        { text: this.$i18n.t("users_create_date_lb"), value: "created_date" },
        { text: this.$i18n.t("users_type_lb"), value: "type" },
        {
          text: this.$i18n.t("users_actions_lb"),
          value: "name",
          sortable: false
        }
      ]
    };
  },
  computed: {
    ...mapGetters(api.namespace, [api.getters.getLoadedUsers]),
    users() {
      return this.getLoadedUsers;
    },
    adminview() {
      if (this.$route.query.admin) {
        return true;
      } else {
        return false;
      }
    },

    // Overwrites from ListConfigurationMixin
    listConfigConfigKey: () => "users",
    listConfigTotalItemCount() {
      return this.users.length;
    }
  },
  mixins: [ListConfigurationMixin],
  methods: {
    ...mapActions(api.namespace, [
      api.actions.createUser,
      api.actions.updateUser,
      api.actions.deleteUser,
      api.actions.importUsers
    ]),
    getType(firebase) {
      if (firebase) {
        return "login";
      }
    },
    editItem(user_id, item) {
      this.setDialogAction("update");
      this.setUserId(user_id);
      this.setDialogItem({ ...item });
      this.dialog = true;
    },
    createItem() {
      this.$router.push("/users/create");
    },
    deleteItem(item) {
      const index = this.users.indexOf(item);

      const payload = {
        user_id: this.users[index].id,
        user_index: index,
        activity: {}
      };

      confirm("Are you sure you want to delete this item?") &&
        this.deleteUser(payload);
    },

    close() {
      this.dialog = false;
    },
    onPaginationChange(value) {
      this.page = value.page;
      this.activePagination = this.listConfigPageSizes.findIndex(
        v => v == value.pageSize
      );
    }
  }
};
</script>
